import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  commonUtils,
  SelectionTileGroup,
  SelectionTileRadioGroupProps,
} from '@sato/components';

import { t } from '@stores/localization';

interface Props
  extends Omit<SelectionTileRadioGroupProps<TrueFalse>, 'items' | 'onChange'> {
  name: string;
}

type TrueFalse = `${boolean}`;

/** A yes/no selection tile that sets the value as either `"true"` or `"false"` (note that these are strings) */
export const HookFormBooleanSelectionTile = (
  props: { name: string } & Props
) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState }) => (
        <SelectionTileGroup<TrueFalse>
          {...props}
          {...field}
          onChange={(value) => field.onChange(value === 'true')}
          value={
            commonUtils.nonNullable(field.value)
              ? `${field.value as boolean}`
              : undefined
          }
          error={fieldState.error?.message}
          items={[
            { title: t('yes'), value: 'true' },
            { title: t('no'), value: 'false' },
          ]}
        />
      )}
    />
  );
};
